<template>
	<div v-if="show" class="tooltip" :style="tooltipStyle" @mouseenter="handleMouseEnter"
		@mouseleave="handleMouseLeave">
		<div class="tooltipL">
			<div class="icon" @click="handleIconClick('favorite')">
				<img src="@/assets/images/ai-icon.png" alt="小问">
			</div>
		</div>
<!--		<template v-if="courseid">-->
			<el-divider direction="vertical"></el-divider>
			<div class="icon" @click="handleIconClick('book')">
				<img src="@/assets/images/book-icon.png" alt="电子书">
			</div>
		<template v-if="isDingHui">
			<el-divider direction="vertical"></el-divider>
			<div class="icon" @click="handleIconClick('visual')">
				<i class="iconfont icon-keshihua"></i>
			</div>
		</template>
	</div>
</template>
 
<script>
	export default {
		props: ['show', 'mouseX', 'mouseY', 'courseid', 'page', 'id'],
		computed: {
			userInfo() {
				return this.$store.state.userInfo
			},
			isDingHui() {
				return this.userInfo && this.userInfo.schoolName === '长沙顶慧';
			},
			tooltipStyle() {
				return {
					left: `${this.mouseX - 35}px`,
					top: `${this.mouseY + 10}px`,
					transform: 'translateX(50%)'
				};
			}
		},
		methods: {
			handleMouseEnter() {
				this.$emit('lock-tooltip');
			},
			handleMouseLeave() {
				this.$emit('release-tooltip');
			},
			handleIconClick(type) {
				this.$emit('icon-click', type);
			}
		}
	};
</script>

<style scoped>
	.tooltip {
		position: fixed;
		background: white;
		border: 1px solid #eee;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		padding: 5px;
		display: flex;
		z-index: 9999;
		pointer-events: auto;
		align-items: center;
	}

	.icon {
		cursor: pointer;
		padding: 6px;
		border-radius: 2px;

		img {
			width: 18px;
			height: 18px;
			display: block;
		}
		.iconfont {
			font-size: 22px;
			font-weight: bold;
			color: #313131;
			display: block;
		}
	}
	
	.tooltipL{
		display: flex;
		align-items: center;
	}

	.icon:hover {
		background-color: #E6F0FF;
	}

	::v-deep .el-divider--vertical {
		height: 2.5em;
		margin: 0 4px;
	}
</style>